@if (HasRequiredPermissions) {
  <div
    *requirePermission="['role-alert-message']"
    name="role-alert-message"
    class="w-full bg-sky-200 border border-sky-600 text-xl font-bold text-center p-4">
    Cette alerte est conditionnee
  </div>
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ `entities.${entityMetaData.EntityName.toLowerCase()}.pluralName` | translate }} ({{ totalSeen }}/{{
        listView()?.entities()?.total
        }})
      </h1>
    </div>
    <app-list-view
      [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
									 [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }"
      [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">
      <!-- Colonne Title -->
      <app-list-table-column key="title" title="{{ 'entities.role.propreties.title' | translate }}" type="text"
      [sortable]="true" align="left"></app-list-table-column>
    </app-list-view>
    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">
      <!-- Poignee interactive (invisible avant le survol)  -->
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white h-full rounded-lg shadow-xl p-1">
        <app-role-detail #roleDetail [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="onItemUpdated($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()"
          [fkPointOfServiceId]="fkPointOfServiceId">
        </app-role-detail>
      </div>
    </div>
  </div>
}
